import React, { useEffect } from "react";
import { useState } from "react";
import { useLocation } from "react-router";
import { useClassInfoEdit } from "../../Hooks";
const EditTime = ({ data, setstep, formSubmit }) => {
  const location = useLocation();
  const [form, setForm] = useState({
    details_session: location.state.data,
  });
  useEffect(() => {
    if (window.$(".clockpicker").length) {
      var inputs = window.$(".clockpicker");
      window.$.each(inputs, function (i, item) {
        window.$(item).clockpicker({
          donetext: "انجام شد",
          align: "right",
          autoclose: true,
        });
      });
    }
    setForm({ details_session: location.state.data });
  }, []);
  const dayOfWeek = [
    {
      id: 0,
      name: "انتخاب کنید",
    },
    {
      id: "str",
      name: "شنبه",
    },
    {
      id: "sun",
      name: "یکشنبه",
    },
    {
      id: "mon",
      name: "دوشنبه",
    },
    {
      id: "thr",
      name: "سه شنبه",
    },
    {
      id: "wen",
      name: "چهارشنبه",
    },
    {
      id: "thu",
      name: "پنجشنبه",
    },
    {
      id: "frd",
      name: "جمعه",
    },
  ];
  const renderDay = id => {
    let result = "";
    dayOfWeek.map(day => {
      if (day.id == id) {
        result = day.name;
      }
    });
    return result;
  };
  return (
    <div className="card p-2">
      <div className="row">
        <div className="col">
          <h5>ویرایش زمان بندی</h5>
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-md-3">
          <select
            className="form-control"
            onChange={({ target: { value } }) => {
              setForm({ ...form, day: value });
            }}
          >
            {dayOfWeek.map((day, key) => {
              return (
                <option key={key} value={day.id}>
                  {day.name}
                </option>
              );
            })}
          </select>
        </div>
        <div className="col-md-3">
          <input
            id="clockpicker-1"
            placeholder="زمان شروع"
            type="text"
            autoComplete="off"
            className="clockpicker form-control"
            onClick={() => {
              if (window.$(".clockpicker").length) {
                var inputs = window.$(".clockpicker");
                window.$.each(inputs, function (i, item) {
                  window.$(item).clockpicker({
                    donetext: "انجام شد",
                    align: "right",
                    autoclose: true,
                  });
                });
              }
              window.$(`#clockpicker-1`).on("change", e => {
                let hours = window.$(e.target).clockpicker().data()
                  .clockpicker.hours;
                let minutes = window.$(e.target).clockpicker().data()
                  .clockpicker.minutes;
                window.$(e.target).attr("data-hours", hours);
                window.$(e.target).attr("data-minutes", minutes);
                if (minutes < 10) {
                  minutes = "0" + minutes.toString();
                }
                if (hours < 10) {
                  hours = "0" + hours.toString();
                }

                setForm({
                  ...form,
                  start: `${hours}:${minutes}`,
                });
              });
            }}
          />
        </div>{" "}
        <div className="col-md-3">
          <input
            id="clockpicker-2"
            placeholder="زمان پایان"
            type="text"
            className="clockpicker form-control"
            autoComplete="off"
            onClick={() => {
              if (window.$(".clockpicker").length) {
                var inputs = window.$(".clockpicker");
                window.$.each(inputs, function (i, item) {
                  window.$(item).clockpicker({
                    donetext: "انجام شد",
                    align: "right",
                    autoclose: true,
                  });
                });
              }
              window.$(`#clockpicker-2`).on("change", e => {
                let hours = window.$(e.target).clockpicker().data()
                  .clockpicker.hours;
                let minutes = window.$(e.target).clockpicker().data()
                  .clockpicker.minutes;
                window.$(e.target).attr("data-hours", hours);
                window.$(e.target).attr("data-minutes", minutes);
                if (minutes < 10) {
                  minutes = "0" + minutes.toString();
                }
                if (hours < 10) {
                  hours = "0" + hours.toString();
                }

                setForm({
                  ...form,
                  end: `${hours}:${minutes}`,
                });
              });
            }}
          />
        </div>
        <div>
          <button
            className="btn btn-warning text-white"
            onClick={() => {
              let newList = [];
              // newList.push(state);
              setForm({
                ...form,
                details_session: [
                  ...form.details_session,
                  { day: form.day, start: form.start, end: form.end },
                ],
              });
            }}
          >
            اضافه کردن
          </button>
        </div>
      </div>
      <div className="row">
        {form &&
          form.details_session &&
          form.details_session.map((day, key) => {
            return (
              <div className="col-md-2" key={key}>
                <div className="card">
                  <div className="card-body">
                    <h3 className="card-title">{renderDay(day.day)}</h3>
                    <h6>{`${day.start} - ${day.end}`}</h6>
                    <button
                      className="btn bg-primary"
                      onClick={() => {
                        setForm({
                          details_session: [...form.details_session].filter(
                            item =>
                              !(
                                item.day == day.day &&
                                item.start == day.start &&
                                item.end == day.end
                              )
                          ),
                        });
                      }}
                    >
                      حذف
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      <div className="row">
        <div className="col">
          <button
            onClick={() => {
              formSubmit(form);
            }}
            className="btn btn-primary"
          >
            ثبت تغییرات
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditTime;
